import { observer } from "mobx-react-lite";
import WarningBeforeAction from "e.sic-platform.webclient/src/components/data-components/WarningBeforeAction";
import { Coin } from "../shop/Coin";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { activityPricesStorage, ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { useCallback, useEffect, useMemo, useState } from "react";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import { Button, Divider, List, ListItem, Menu, Stack } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ArrowForward } from "@mui/icons-material";

export interface IPurchaseConfirmation {
    visible: boolean;
    toggle(): void;
    app: ActivityTypes;
    confirm(): void;
}

export default observer(function PurchaseConfirmation(props: IPurchaseConfirmation) {
    const price = activityPricesStorage.getPrice(props.app);
    const remainingBalance = creditBalanceStorage.balance - price;
    const [confirmationDisabled, setConfirmationDisabled] = useState(false);
    const [openPrice, setOpenPrice] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const openPriceMenu = useCallback((e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget);
        setOpenPrice(true);
    }, [])

    const closePriceMenu = useCallback(() => {
        setAnchorEl(null);
        setOpenPrice(false);
    }, [])

    const goToShop = useCallback(() => {
        window.location.href = "/shop";
    }, [])

    useEffect(() => {
        creditBalanceStorage.validateRemainingBalance(props.app).then((result) => {
            setConfirmationDisabled(!result);
        });
    }, [props.app]);

    return (
        <>
            <Button onClick={openPriceMenu} sx={{ml: 3}} variant="contained" endIcon={<KeyboardArrowDownIcon />}>
                <Coin color="default" amount={price} text={translationService.translate("general.apps.priceMenu.button")}/>
            </Button>
            <Menu
                open={openPrice}
                onClose={closePriceMenu}
                anchorEl={anchorEl}
                sx={{top: 5}}
            >
                <Stack p={3} width="20vw">
                    <div>{translationService.translate("general.apps.priceMenu.description")}</div>
                    <List>
                        <ListItem disableGutters secondaryAction={<Coin amount={creditBalanceStorage.balance} text=" "/>}>{translationService.translate("general.apps.priceMenu.currentBalance")}</ListItem>
                        <ListItem disableGutters secondaryAction={<Coin amount={price} text=" "/>}>{translationService.translate("general.apps.priceMenu.appPrice")}</ListItem>
                        <Divider component="li" />
                        <ListItem disableGutters secondaryAction={<Coin amount={remainingBalance} text=" "/>}>{translationService.translate("general.apps.priceMenu.remainingBalance")}</ListItem>
                    </List>
                    <Button onClick={goToShop} endIcon={<ArrowForward sx={{marginLeft: "auto"}}/>} variant="contained">{translationService.translate("general.apps.priceMenu.shopLink")}</Button>
                </Stack>
            </Menu>
            <WarningBeforeAction
                isVisible={props.visible}
                titleKey="shop.appPurchase.title"
                toggleModal={props.toggle}
                optionalWarningKey={confirmationDisabled ? "shop.balance-exceeded" : ""}
                buttonOk={{
                    textKey: "shop.appPurchase.confirm",
                    action: () => {
                        props.confirm();
                        props.toggle();
                    },
                    disabled: confirmationDisabled
                }}
            >
                <div>{translationService.translate("shop.appPurchase.description")}</div>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Coin text={translationService.translate("shop.coins")} amount={price}/>
                </div>
            </WarningBeforeAction>
        </>
    )
})